module.exports = __webpack_public_path__ + "static/media/flexline_black_logo_ee.ef3d2970.png";